module.exports = __webpack_public_path__ + "static/media/aneka-makanan.73a55f89.jpeg";